var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('Head')],1),_c('div',{staticClass:"main"},[_c('RouterView')],1),_c('div',{staticClass:"foot"},[_c('Foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }